import { Checkbox, IconSettings } from '@salesforce/design-system-react';
import React, { BaseSyntheticEvent } from 'react';

interface IProps {
    label: string;
    config: {
       isRequired?: boolean;
       isDisabled?: boolean;
       variant: 'base' | 'toggle' 
    };
    onToggleChanged: (e: BaseSyntheticEvent, value: boolean) => void;
    value: boolean;
    key: string;
    customToggleLabel?: {
        toggleDisabled: string;
        toggleEnabled: string; 
    };
}

export const CQCheckbox = (props: IProps) => {
    const { label, config, onToggleChanged, value, customToggleLabel } = props;

    const onToggled = (e: BaseSyntheticEvent, { checked }: { checked: boolean }) => {
        onToggleChanged(e, checked);
    }

    return(
        <IconSettings iconPath="/assets/icons">
            <div className="slds-grid slds-grid_pull-padded slds-grid_vertical-align-center">
                <div className="slds-col_padded">
                    <Checkbox
                        key={props.key}
                        labels={{
                            label: label,
                            toggleDisabled: customToggleLabel?.toggleDisabled || 'Disabled', 
                            toggleEnabled: customToggleLabel?.toggleEnabled || 'Enabled',
                        }}
                        checked={value}
                        disabled={config.isDisabled || false}
                        required={config.isRequired || false}
                        variant= {config.variant}
                        onChange= {onToggled}
                    />
                </div>						
            </div>
        </IconSettings>
    )
}